import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Typography, Card, Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { RESOURCE } from '../../config/constants/alerts';
import { UPDATE_PASSWORD, UPDATE_PASSWORD_SUCESS } from '../../state/user/types';
import { STATUS } from '../../config/constants/states';
import PropTypes from 'prop-types';

const { Title } = Typography;

const Profile = ({ user, updatePassword, passwordIsUpdated, resetStatus }) => {

  const [form] = Form.useForm();

  const submitForm = (data) => {
    updatePassword({ ...data });
  };

  useEffect(() => {
    if (passwordIsUpdated === STATUS.SUCCESS) {
      resetStatus();
      message.success('Contraseña actualizada satisfactoriamente', 10);
    };
    if (passwordIsUpdated === STATUS.ERROR) {
      resetStatus();
    }
  }, [passwordIsUpdated]);

  return (
    <React.Fragment>
      <Card>
        <Row>
          <Title level={3} ellipsis className="mb-4">
            Datos personales
          </Title>
        </Row>
        <Row>
          <Col sm={12} xs={24} className="mb-4">
            <p><b>Nombre</b></p>
            {user.first_name} {user.last_name}
          </Col>
          <Col sm={12} xs={24} className="mb-4">
            <p><b>Rut</b></p>
            {user.rut}-{user.dv}
          </Col>
          <Col sm={12} xs={24} className="mb-4">
            <p><b>Email</b></p>
            {user.email}
          </Col>
          <Col sm={12} xs={24} className="mb-4">
            <p><b>Status</b></p>
            {user.status}
          </Col>
        </Row>
      </Card>
      <Card>
        <Row>
          <Title level={3} ellipsis className="mb-4">
            Actualizar contraseña
          </Title>
        </Row>
        <Row>
          <Form
            form={form}
            layout="vertical"
            onFinish={submitForm}
            autoComplete="on"
          >
            <Row gutter={24}>
              <Col md={24} xs={24} className="position-relative">
                <Form.Item
                  label="Contraseña actual"
                  name={'old_password'}
                  rules={[
                    {
                      required: true,
                      message: 'Debes ingresar tu contraseña actual'
                    }
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col sm={24} xs={24} className="position-relative">
                <Form.Item
                  label="Nueva contraseña"
                  name={'new_password'}
                  rules={[
                    {
                      required: true,
                      message: 'Debes ingresar tu nueva contraseña'
                    }
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col sm={24} xs={24} className="position-relative">
                <Button size="large" type="primary" htmlType="submit">Cambiar contraseña</Button>
              </Col>
            </Row>
          </Form>
        </Row>
      </Card>
    </React.Fragment>
  );
};

Profile.propTypes = {
  user: PropTypes.object.isRequired,
  updatePassword: PropTypes.func.isRequired,
  passwordIsUpdated: PropTypes.bool.isRequired,
  resetStatus: PropTypes.func.isRequired,
};

const data = state => ({
  user: state.user.user,
  passwordIsUpdated: state.user.passwordIsUpdated
});

const actions = dispatch => ({
  updatePassword: (data) => dispatch({ type: UPDATE_PASSWORD, payload: { ...data, resource: RESOURCE.UPDATE_PASSWORD } }),
  resetStatus: () => dispatch({ type: UPDATE_PASSWORD_SUCESS, payload: STATUS.PENDING }),
});

export default connect(data, actions)(Profile);